module.exports = __webpack_public_path__ + "static/media/baby_bear_looking_up.82f2bea1.png";